import { Login } from './Login';
import * as Flux from 'dg-web-shared/lib/Flux';
import { useStore } from 'dg-web-shared/lib/Flux';
import * as AuthTokenState from '../state/AuthTokenState';
import { Enforcement } from './Enforcement';
import { css, injectGlobal } from '@emotion/css';
import { ParkingCheckThemeProvider } from './ParkingCheckThemeProvider.tsx';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { useSystemLanguage } from 'dg-web-shared/lib/useSystemLanguage.ts';
import { LanguageProvider } from 'dg-web-shared/lib/Localization.tsx';

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
injectGlobal`
    html, body {
        margin: 0;
        padding: 0;
        height: 100%;
        position: relative;
    }

    #app-container {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }

    input[type="search"]::-webkit-search-decoration {
        display: none;
    }
`;

function AppContainer() {
    const { storeState } = useStore(store => ({
        authToken: AuthTokenState.get(store),
    }));

    if (
        storeState.authToken.authToken &&
        storeState.authToken.authToken.length > 0
    ) {
        return <Enforcement />;
    } else {
        return <Login />;
    }
}

export function App({ allState }: { allState: Flux.Store }) {
    const { language, setLanguage } = useSystemLanguage();
    return (
        <div
            className={css({
                fontFamily: 'Roboto',
                height: '100%',
                maxWidth: '480px',
            })}
        >
            <Flux.StoreContext.Provider value={allState}>
                <LanguageProvider context={{ language, setLanguage }}>
                    <ParkingCheckThemeProvider>
                        <CssBaseline />
                        <GlobalStyles
                            styles={{
                                body: { backgroundColor: 'transparent' },
                            }}
                        />
                        <AppContainer />
                    </ParkingCheckThemeProvider>
                </LanguageProvider>
            </Flux.StoreContext.Provider>
        </div>
    );
}
